'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _lodash = require('lodash');

var _timeUtil = require('../../../common/utils/timeUtil');

var _elementConstants = require('../../../common/elements/elementConstants');

var TYPES = _interopRequireWildcard(_elementConstants);

var _elementsConstants = require('../../../common/elements/elementsConstants');

var ELEMENTS_ACTION_TYPES = _interopRequireWildcard(_elementsConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Constants
var updateDeepChildrenMod = function updateDeepChildrenMod(state, ids) {
    var timestamp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, _timeUtil.getTimestamp)();
    return state.withMutations(function (mutableState) {
        ids.forEach(function (id) {
            return mutableState.set(id, timestamp);
        });
    });
};

// Utils
/**
 * deepChildrenModCache
 * ====================
 * This is intended to be used for performance gains to prevent unnecessary recalculations of the 'deep' children
 * for an element.
 * The getChildrenDeep operation is relatively expensive and would usually be executed on any element change (even
 * if the element was entirely unrelated).
 *
 * This cache stores a timestamp of the last time that the children of a board were changed (this is performed in
 * the elements reducer).
 * The getChildrenDeepSelector will then use this cache to determine whether its state needs to be updated, or whether
 * the previous result can be used instead.
 */

// Lib


var handleElementLoad = function handleElementLoad(state, action) {
    var ids = (0, _lodash.reduce)(action.elements, function (idArray, el) {
        var parentId = el.location.parentId;
        parentId && idArray.push(parentId);
        return idArray;
    }, []);
    return updateDeepChildrenMod(state, ids);
};

var handleElementCreateOrDelete = function handleElementCreateOrDelete(state, action) {
    var ids = [action.location.parentId];
    return updateDeepChildrenMod(state, ids);
};

var isMoveRelevant = function isMoveRelevant(_ref) {
    var from = _ref.from,
        location = _ref.location;
    return from.parentId !== location.parentId;
};
var getMoveIds = function getMoveIds(_ref2) {
    var from = _ref2.from,
        location = _ref2.location;
    return [location.parentId, from.parentId];
};

var handleElementMoveMulti = function handleElementMoveMulti(state, action) {
    var ids = (0, _lodash.uniq)((0, _lodash.flatMap)(action.moves.filter(isMoveRelevant).map(getMoveIds)));
    if (ids.length === 0) return state;

    return updateDeepChildrenMod(state, ids);
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Immutable.Map();
    var action = arguments[1];

    switch (action.type) {
        case ELEMENTS_ACTION_TYPES.ELEMENTS_LOAD:
            return handleElementLoad(state, action);
        case TYPES.ELEMENT_CREATE:
        case TYPES.ELEMENT_DELETE:
            return handleElementCreateOrDelete(state, action);
        case TYPES.ELEMENT_MOVE_MULTI:
            return handleElementMoveMulti(state, action);
        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/cache/deepChildrenModCacheReducer.js
// module id = 1958
// module chunks = 0